module.exports = __webpack_public_path__ + "static/media/SourceSansPro-BlackItalic.9912ce73.ttf";